
import { createSlice } from '@reduxjs/toolkit';
import { setLocalStore } from 'utils/Helper';
import clientService from '../../services/service';
let obortApiController, geUserInfoController;

// map backend menu names to frontend module
const menuNameMap = {
  "Commodities": "material",
  "Buy-outs": "buyout",
  "Commodity Material Database": "database",
  "Buyout Material Database": "btdatabase",
  "Field Reporter": "fieldreporter",
  "Vendor List": "vendor",
  "Database": "database",
  "PO Lines Database": "polinesdb",
  "Floor List": "floor",
  //"Area List": "area",
  "Area List": "materialarea",
  "Field Reporter Breakdown Table": "subsystem",
  "PTO Calendar": "ptocalendar",
  "Tech Calendar": "techcalendar",
  "Look Ahead Branch Summary": "lookbranchsummary"
};

// Default permissions config (deny by default)
const DEFAULT_PERMISSIONS = {
  materialarea: { view_perms: 0 },
  floor: { view_perms: 0 },
  fieldreporter: { view_perms: 0 },
  area: { view_perms: 0 },
  subsystem: { view_perms: 0 },
  material: { view_perms: 0 },
  database: { view_perms: 0 },
  vendor: { view_perms: 0 },
  buyout: { view_perms: 0 },
  polinesdb: { view_perms: 0 },
  techcalendar: { view_perms: 0 },
  ptocalendar: { view_perms: 0 },
  report: { view_perms: 0 },
  lookbranchsummary: { view_perms: 0 },
  btdatabase: { view_perms: 0 },
};

const usersInitialState = {
  user : {
    name : ""
  },
  userInfo : [],
  divisionInfo: [],
  isAdminUser: false,
  permission: { ...DEFAULT_PERMISSIONS },
  menuList: {},
  userPermList: {},
  adminVideoInfo: [],
  allMenu: [],
  pageTitle: '',
  isSideMenuCollapse: 1,
  isStateCollapse: null,
  notyCount: 0,
  notyData: {},
  sidebarHelpInfo: {},
  permissionsLoaded: false,
}

export const usersSlice = createSlice({
  name: 'users',
  initialState: usersInitialState,
  reducers: {
    updateUser: (state, action) => {
      state.current = action.payload
    },
    updateUserInfo: (state, action) => {
      state.userInfo = action.payload;
      state.user.name = action.payload.userInfo.name;
      const userRole = state?.userInfo?.userInfo?.role_id;

      // Check for menu_item_id to menu_name
      const menuIdToName = {};
      if (Array.isArray(action.payload.menuPermission)) {
        action.payload.menuPermission.forEach(menu => {
          menuIdToName[menu.id] = menu.menu_item_title.trim();
        });
      }

      // Always use backend permissions if available, fallback to default
      let permissionObj = { ...DEFAULT_PERMISSIONS };
      if (Array.isArray(action.payload.userPermission)) {
        action.payload.userPermission.forEach((perm) => {
          const mappedName = menuIdToName[perm.menu_item_id];
          const key = menuNameMap[mappedName] || mappedName || perm.menu_item_id;
          // Only override if backend permission is present
          permissionObj[key] = { ...permissionObj[key], ...perm };
        });
      }

      // special handling for ptocalendar
      if (!permissionObj.ptocalendar?.id) {
        if (userRole === 2 || userRole === 3) {
          permissionObj.ptocalendar = { view_perms: 1, edit_perms: 1 };
        } else {
          permissionObj.ptocalendar = { view_perms: 0 };
        }
      }

      state.permission = permissionObj;
      state.isAdminUser = userRole === 2 || userRole === 3;
      if (Array.isArray(action.payload.menuPermission) && action.payload.menuPermission.length) {
        state.menuList = action.payload.menuPermission;
      }
      if (Array.isArray(action.payload.userPermission) && action.payload.userPermission.length) {
        state.userPermList = action.payload.userPermission;
      }
      state.isSideMenuCollapse = action.payload?.userSideMenuSetting?.isSideMenuCollapse ? parseInt(action.payload?.userSideMenuSetting?.isSideMenuCollapse) : 1;
      state.isStateCollapse = action.payload?.userStateCollapse?.isStateCollapse ? parseInt(action.payload?.userStateCollapse?.isStateCollapse) : 1;
      state.notyCount = action.payload.cmpNotificationCount;
      state.notyData = action.payload.cmpNotificationData;
      state.permissionsLoaded = true;
    },
    updateAdminVideo: (state, action) => {
        state.adminVideoInfo = action.payload
    },
    updateAllMenu: (state, action) => {
        state.allMenu = action.payload
    },
    updatePageTitle: (state, action) => {
        state.pageTitle = action.payload
    },
    setDivisionInfo: (state, action) => {
		setLocalStore('divisionInfo', action.payload)
        state.divisionInfo = action.payload
    },
    setSideMenuColleapse: (state, action) => {
        state.isSideMenuCollapse = action.payload
    },
    setStateFilterColleapse: (state, action) => {
        state.isStateCollapse = action.payload
    },
    setSidebarHelpInfo: (state, action) => {
      state.sidebarHelpInfo = action.payload
    }
  },
})

export const updateNotificationStatus = (data) => async (dispatch) => {
  await clientService.put("user/updateNotification", data);
  dispatch(getUserInfo());
};

export const saveNewUser = (newUserData) => async (dispatch) => {
  const response = await clientService.post('/user', newUserData)
  dispatch(updateUser(response.data.createUser))
}

export const getUserInfo = () => async (dispatch) => {
  if (geUserInfoController) {
    geUserInfoController.abort()
  }
  geUserInfoController = new AbortController();
  const response = await clientService.get("user-info", {signal: geUserInfoController.signal});
  if (response?.data?.data) {
    dispatch(updateUserInfo(response?.data?.data));
  }
};

export const updateUserDetails = (data) => async (dispatch) => {
  await clientService.put("user/update", data);
  dispatch(getUserInfo());
};

export const updateUserCollapseSettings = (data) => async (dispatch) => {
    await clientService.post("user/sidemenu-collapse", data);
};

export const updateReduxAllMenu = (data) => async (dispatch) => {
  dispatch(updateAllMenu(data));
};

export const updateReduxPageTitle = (data) => async (dispatch) => {
  dispatch(updatePageTitle(data));
};

export const getAdminVideos = (id) => async (dispatch) => {
  // const response = await clientService.get('admin-video/'+id);
  // dispatch(updateAdminVideo(response.data.data));
  dispatch(updateAdminVideo([]));
}

export const getRightBarTrainingHelp = (slugName) => async (dispatch) => {
  const response = await clientService.get('get-rightbar-training/'+slugName);
  dispatch(setSidebarHelpInfo(response?.data?.data));
}

export const getDivisionPayPeriod = () => async (dispatch) => {
    if (obortApiController) {
        obortApiController.abort()
    }
    obortApiController = new AbortController();
    const response = await clientService.get("get-payperiod", {signal:  obortApiController.signal});
    dispatch(setDivisionInfo(response?.data?.data || []));
};

export const { updateUser, updateUserInfo, updateAdminVideo, setDivisionInfo, setSideMenuColleapse, setStateFilterColleapse, updateAllMenu, updatePageTitle, setSidebarHelpInfo } = usersSlice.actions
export const usersState = (state) => state.users
export default usersSlice.reducer
